"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _clock = _interopRequireDefault(require("@spothero/icons/clock"));

var _time = _interopRequireDefault(require("@spothero/utils/time"));

var _Select = _interopRequireDefault(require("../Select/Select"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var TimePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TimePicker, _Component);

  var _super = _createSuper(TimePicker);

  function TimePicker(props) {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, TimePicker);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedTime: _this.props.selectedTime
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onSelectChange", function (_ref) {
      var value = _ref.value;

      _this.setState({
        selectedTime: value
      });
    });
    var step = props.step,
        disableBefore = props.disableBefore,
        disableAfter = props.disableAfter,
        displayFormat = props.displayFormat;
    var dayStart = (0, _moment.default)().startOf('day');
    var timesParams = {
      step: step
    };

    if (disableBefore) {
      timesParams.ignoreBefore = (0, _moment.default)(disableBefore, 'hh:mm A').diff(dayStart, 'minutes');
    }

    if (disableAfter) {
      timesParams.ignoreAfter = (0, _moment.default)(disableAfter, 'hh:mm A').diff(dayStart, 'minutes');
    }

    _this._times = (0, _map.default)(_context = _time.default.getTimes(timesParams)).call(_context, function (_ref2) {
      var formatted = _ref2.formatted;
      return {
        value: formatted,
        label: displayFormat ? _time.default.getAsMoment(formatted).format(displayFormat) : formatted
      };
    });
    return _this;
  }

  (0, _createClass2.default)(TimePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onChange = this.props.onChange;
      var selectedTime = this.state.selectedTime;

      if (selectedTime !== prevState.selectedTime && onChange) {
        onChange(selectedTime);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          label = _this$props.label,
          placeholder = _this$props.placeholder,
          useIcon = _this$props.useIcon,
          iconPosition = _this$props.iconPosition,
          name = _this$props.name,
          disabled = _this$props.disabled,
          attrs = (0, _objectWithoutProperties2.default)(_this$props, ["className", "label", "placeholder", "useIcon", "iconPosition", "name", "disabled"]);
      var spreadProps = (0, _omit.default)(attrs, ['onChange', 'step', 'displayFormat', 'disableBefore', 'disableAfter', 'selectedTime']);
      var selectedTime = this.state.selectedTime;
      var classes = (0, _classnames.default)('TimePicker', {
        'TimePicker-with-icon': useIcon
      }, className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, label, /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({
        ref: function ref(node) {
          _this2._select = node;
        },
        name: name,
        defaultValue: selectedTime,
        onChange: this._onSelectChange,
        items: this._times,
        disabled: disabled,
        icon: useIcon ? /*#__PURE__*/_react.default.createElement(_clock.default, {
          className: "Icon-clock"
        }) : null,
        iconPosition: iconPosition,
        placeholder: placeholder
      }, spreadProps)));
    }
  }, {
    key: "node",

    /**
     * Getter for the select DOM element.
     *
     * @public
     * @returns {Element} - The select element.
     */
    get: function get() {
      return this._select.node;
    }
  }]);
  return TimePicker;
}(_react.Component);

exports.default = TimePicker;
(0, _defineProperty2.default)(TimePicker, "defaultProps", {
  useIcon: true,
  step: 30,
  iconPosition: 'right',
  displayFormat: 'hh:mm A'
});